
import React, { Component } from 'react';
import { connect } from 'react-redux'; 

//Bootstrap component
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';


// components
import ScaleSliderResponse from './ScaleSliderResponse/ScaleSliderResponse';
import { processResponse, processItemResponse } from '../../../../utilities/processResponse';

//Assets
import './ScaleSliderItem.css';

//Actions
import { getAnsweredQuestionCount, getQuestionList, putAllItemResponses, resetInfiniteSlider } from '../../../../actions/SurveyAction';

import { isMobile, isTablet, isAndroid } from 'react-device-detect';
class ScaleSliderItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            naCheck:false,
            undoIcon:false
        }
        this.restoreArr = [];
    }

    componentDidUpdate(prevProps) {
        var questionId = this.props.scrollToQuestionId;

        if (questionId !== null) {
            if (this.props.scrollToQuestionId !== prevProps.scrollToQuestionId) {
                this.scrollToQuestion(questionId);
            }
        }
    }

    resetAll = (event, configuration, rateeKey, naType) => {
        const { questionItemList, dispatch, answeredQuestionCount } = this.props;
        const { key } = configuration;
        const itemTagKey = key;
        var itemList = questionItemList[key];

        try {
            var pointInputBox = document.getElementsByClassName(`infinite_slider_${itemTagKey}_${rateeKey}`);
            var pointInputError = document.getElementsByClassName(`pointInputError_${itemTagKey}`);
            var pointOption = document.getElementsByName(`pointOption`);
            var sliderThumb = document.getElementById(`${configuration.cssClass}_${key}`);
            var sliderThumbChild = sliderThumb.getElementsByClassName("rangeslider__handle")[0];


            for (const key in pointOption) {
                if (pointOption.hasOwnProperty(key)) {
                    const element = pointOption[key];

                    if (element.value && element.value !== "") {
                        element.value = "";
                    }
                }
            }
            itemList.filter((items, i) => {
                var ratees = items.ratees;
                if (items.key === itemTagKey) {

                    if (items.itemResponses.length > 0) {
                        this.restoreArr = items.itemResponses
                        this.setState({undoIcon:true});
                    }

                    let responseLen = items.itemResponses.length;

                    if (naType === "clear" || typeof naType === "boolean") {
                        items.itemResponses = [];
                        items.isAnswer = false;


                        if (naType !== "clear") {
                            this.handleNaDisabled(naType, itemTagKey);
                            items.isNA = naType === false ? false : true;
                        }
                        // items.isRequired = false;

                        this.handleNaClick(naType);
                        var disabledSlider = naType === false || naType === "clear" ? false : true;
                        sliderThumbChild.style.background = "#fff";
                        dispatch(resetInfiniteSlider(disabledSlider));
                        dispatch(getQuestionList(questionItemList));
                    } else {
                        this.setState({undoIcon:false})
                        let remainCount = answeredQuestionCount + 1;

                        items.userResponse =  this.restoreArr;
                        items.isAnswer = true;
                        items.isRequired = true;
                        items.isNA = false;
                        sliderThumbChild.style.background = "#0f5ea0";

                        if (responseLen !== 0) {
                            // dispatch(resetSlider(this.restoreArr[arrLen].userResponseDescription))
                            dispatch(getAnsweredQuestionCount(remainCount));
                        }
                    }
                }
            });
        } catch (error) {
            console.log("Exception:While reset element in scale slider:_", error);
        }
    }

    handleNaDisabled = (naType, itemTagKey) => {
        var scrollDiv = document.getElementById(`ScrollDiv_${itemTagKey}`);
        scrollDiv.style.fontStyle = naType === false ? 'normal' :'italic';
        scrollDiv.style.color = naType === false ? '#0f5ea0' :'#8787';
    }

    handleNaClick = (naType) => {
        var circles = document.getElementsByClassName("left-circle-na");

        for (const key in circles) {
            if (circles.hasOwnProperty(key)) {
                const element = circles[key];
                element.style = "border:2px slid #fff"
                element.style.background = naType ? "rgb(242, 242, 242)" : "none";
                element.style.zIndex = 0;
            }
        }
    }

    /**
     * Method to scroll respective element based on id
     *
     * @param { questionId:string }
     *
     */
    scrollToQuestion = (questionId) => {
        var scrollDiv = document.getElementById("ScrollDiv_" + questionId);
            scrollDiv.style.paddingTop = "40px";;
            scrollDiv.scrollIntoView({top:scrollDiv.offsetTop, behavior:"smooth"});
    }

    renderOneSlider(responseConfiguration) {
        const { configuration, questionItemList, pageInstrumentConfiguration, itemResponses, itemTempResponses, dependencies, pageList, pageNumber, activePageKey, survey, assessmentInfosForDataCollection, dataCollectionGuid } = this.props;
        let uniqueId = [this.currentRatee.key, configuration.key, responseConfiguration.response].join(":");
        let buttonGroup = [this.currentRatee.key, configuration.key].join(":");
        let key = this.currentRatee.dataCollectionGuid;
        const { scales } = pageInstrumentConfiguration;
        const scaleKey = configuration.scaleKey;
        const renderingHint = scales[configuration.scaleKey].renderingHint;
        const assessmentObj = assessmentInfosForDataCollection.assessmentInfosForDataCollection || [];
        const itemKey = configuration.key;

        return (
            <td className="_sliderTd _ItemSlider" key={uniqueId}> 
            {/*  */}
                    <ScaleSliderResponse
                        itemKey={itemKey}
                        className={scales[scaleKey].className}
                        configuration={scales[scaleKey]}
                        key={configuration.key}
                        id={configuration.key}
                        buttonGroup={configuration.key}
                        items={configuration}
                        dependencies={dependencies}
                        pageList={pageList}
                        survey={survey}
                        pageNumber={pageNumber}
                        handleRequired={() => this.props.handleRequired()}
                        activePageKey={activePageKey}
                        handleItemResponse={(itemKey, itemResponsesSet, type, dataCollectionGuid) => this.props.handleItemResponse(itemKey, itemResponsesSet, type, dataCollectionGuid)}
                        questionItemList={questionItemList}
                        itemResponses={itemResponses}
                        itemTempResponses={itemTempResponses}
                        rateeKey={key}
                        ratees={assessmentObj}
                        putAllForItemCollection={this.props.putAllForItemCollection}
                        dataCollectionGuid={dataCollectionGuid}
                        handleDependentItem={(itemKey, response, pageDep)=>this.props.handleDependentItem(itemKey, response, pageDep)}
                        getResPonsesOnLoad={(itemKey, itemResponseSet, dataGuidId) => this.props.getResPonsesOnLoad(itemKey, itemResponseSet, dataGuidId)}

                    />
            </td>
        );
    }

    renderPointSliderGroup(ratee, me) {
        const { configuration } = this.props;
        this.currentRatee = ratee;
        this.currentButtonGroup = [this.currentRatee.key, configuration.key].join(":");
        return this.renderOneSlider(configuration, this);
    }

    scaleSliderNaCheck = (event, configuration) => {
        try {
            var naCheck = event.target.checked;
            var surveyItem = document.getElementById(`survey-item-block_${configuration.key}`);
            var itemKey = configuration.key;
            this.setState({naCheck:naCheck});

            if (naCheck) {
                surveyItem.style.background = "#F2F2F2";
                surveyItem.style.color = "#ACACAC";

                var responseSet = this.props.itemResponses[itemKey] = {};
                var itemResponses = [{
                    "itemType"     : configuration.itemType,
                    "buttonGroup"  : null,
                    "sequence"     : 1,
                    "isNa"         : naCheck,
                    "response"     : null,
                    "responseValue": null,
                    "openEnd"      : null,
                    "serverStatus" : 0,
                    "hasPosted"    : 0
                }];

                processItemResponse(itemKey, responseSet, itemResponses);
                this.props.handleItemResponse(configuration.key, this.props.itemResponses, "itemChange");
            } else {
                surveyItem.style.background = "";
                surveyItem.style.color = "#000";
            }

            this.resetAll(null, configuration, null, naCheck);
        } catch (error) {
            console.log("Exception: while click on N/A check box in point assignment:_", error)
        }
    }

    resetScaleSliderResponse = (event, configuration) => {
        try {
            const lenRestoreArr = this.restoreArr.length - 1;
            this.setState({undoIcon:false});

            if (this.restoreArr[lenRestoreArr].responseValue !== undefined) {
                this.props.dispatch(resetInfiniteSlider(this.restoreArr[lenRestoreArr].responseValue))
            }

            this.resetAll(null, configuration, null, "reset");

        } catch (error) {
            console.log("Exception: while reset scale slider value:_", error)
        }
    }

    /**
     * Method to load spinner image
     *
     */
    renderSpinner = (configuration) => {
        return <i className={`fa fa-spinner fa-spin fa_${configuration.key} itemSpinnerText`}
                  style={{"fontSize":"25px", "display":"none"}}
                ></i>
    }

    renderView = (configuration, rateeKey, itemKey) => {
        const { questionItemList, pageInstrumentConfiguration, dataCollectionGuid, itemResponses, itemTempResponses, pageList, activePageKey, dependencies, survey, pageNumber, assessmentInfosForDataCollection } = this.props;
        const { scales } = pageInstrumentConfiguration;
        const scaleKey = configuration.scaleKey;
        const assessmentObj = assessmentInfosForDataCollection.assessmentInfosForDataCollection || [];

        return <ScaleSliderResponse
                    itemKey={itemKey}
                    className={scales[scaleKey].className}
                    configuration={scales[scaleKey]}
                    key={configuration.key}
                    id={configuration.key}
                    buttonGroup={configuration.key}
                    items={configuration}
                    dependencies={dependencies}
                    handleRequired={() => this.props.handleRequired()}
                    pageList={pageList}
                    survey={survey}
                    pageNumber={pageNumber}
                    activePageKey={activePageKey}
                    handleItemResponse={(itemKey, itemResponsesSet, type, dataCollectionGuid) => this.props.handleItemResponse(itemKey, itemResponsesSet, type, dataCollectionGuid)}
                    questionItemList={questionItemList}
                    itemResponses={itemResponses}
                    itemTempResponses={itemTempResponses}
                    rateeKey={dataCollectionGuid}
                    ratees={assessmentObj}
                    putAllForItemCollection={this.props.putAllForItemCollection}
                    dataCollectionGuid={dataCollectionGuid}
                    handleDependentItem={(itemKey, response, pageDep)=>this.props.handleDependentItem(itemKey, response, pageDep)}
                    getResPonsesOnLoad={(itemKey, itemResponseSet, dataGuidId) => this.props.getResPonsesOnLoad(itemKey, itemResponseSet, dataGuidId)}

                />
    }

    render() {
        const { configuration, questionItemList, pageInstrumentConfiguration, assessmentInfosForDataCollection } = this.props;
        const { scales, itemNaUncheckedButtonKey, itemResetButtonKey, itemRestoreButtonKey, buttons, sections, properties } = pageInstrumentConfiguration;

        const scaleKey = configuration.scaleKey;
        const tempScales = scales[scaleKey].scaleResponses;

        const scaleCompIcons = questionItemList.filter((item, i) => {
            if (item.key === configuration.key) {
                return item.userResponse.length || 0;
            }
        });

        const ratees = assessmentInfosForDataCollection.assessmentInfosForDataCollection || [];

        var isDeleteIcon = false;
        var rateeKey = null ;
        var jsx = '';
        var naResponse = scales[scaleKey].naResponse || null;

        for (const key in ratees) {
            if (ratees.hasOwnProperty(key)) {
                const element = ratees[key];
                rateeKey = element.key;
            }
        }
        let OSName = "Unknown OS";
        if (navigator.userAgent.indexOf("Win") != -1) OSName = "Windows";
        if (navigator.userAgent.indexOf("Mac") != -1) OSName = "Macintosh";
        if (navigator.userAgent.indexOf("Linux") != -1) OSName = "Linux";
        if (navigator.userAgent.indexOf("Android") != -1) OSName = "Android";
        if (navigator.userAgent.indexOf("like Mac") != -1) OSName = "iOS";

        var groupIconsClass = configuration.hasItemResetButton || configuration.hasItemRestoreButton || naResponse !== null ? "ItemGroupIcon" : null;

        if (ratees.length < 2) {
            jsx = (
                <div data-id={configuration.key} name={`survey-item-block`} id={`survey-item-block_${configuration.key}`} className={`survey-item-block_${configuration.key}`} style={(isMobile || isTablet) && isAndroid ? {position:'relative', top:29} : null}>
                    <Row
                        id={`ScrollDiv_${configuration.key !== undefined ? configuration.key:null}`}
                        className={configuration.itemText && configuration.itemText !== null ? "_ItemTextCss justify-content-md-center" : null}>
                        {
                            configuration.itemText && configuration.itemText !== null ?
                                <>
                                    <Col xs={1}>
                                        {/* <i className="fa fa-spinner fa-spin" style={{"fontSize":"20px"}}></i> */}
                                    </Col>
                                    <Col
                                        xs={naResponse !== null && naResponse !== undefined && configuration.hasItemResetButton && configuration.hasItemRestoreButton ? 10 : 10}
                                        className="itemText"
                                    >
                                        {configuration.isRequiredLabel === true ? <span className={"_AsteriskMark"}>{properties.requiredIndicator}</span> :''}
                                        <span className="itemTag" dangerouslySetInnerHTML={{__html:configuration.itemTag}}></span>
                                        <span dangerouslySetInnerHTML={{__html: processResponse(configuration.itemText)}}></span>
                                    </Col>
                                    <Col xs={1}></Col>
                                </>
                            :null
                        }

                        {configuration.itemText && configuration.itemText !== null ?
                            <Col xs={1}
                                className={groupIconsClass}
                                style={{display: naResponse !== null && naResponse !== undefined && configuration.hasItemResetButton && configuration.hasItemRestoreButton ? "block":"none"}}
                            >
                                {naResponse !== null && naResponse !== undefined ? <span>
                                    <Form.Check
                                        className={`_ItemNaUncheckedButton ${buttons[itemNaUncheckedButtonKey].buttonCssClass}`}
                                        type="checkbox"
                                        onChange={(event) => this.scaleSliderNaCheck(event, configuration)}
                                    />
                                        <span>{buttons[itemNaUncheckedButtonKey].buttonText}</span>
                                </span>:null}
                                {
                                    configuration.itemText !== null && configuration.hasItemResetButton ?
                                        <span
                                            className={`_ItemResetButton ${buttons[itemResetButtonKey].buttonCssClass}`}
                                            onClick={(event) => this.resetAll(event, configuration, rateeKey, "clear")}
                                        >
                                            {
                                                (scaleCompIcons.length > 0 && this.state.undoIcon === false) || scaleCompIcons.length > 0 ?
                                                    <i className={buttons[itemResetButtonKey].buttonFontAwesome}></i>
                                                :
                                                    isDeleteIcon = true
                                            }
                                        </span>
                                    :null
                                }
                                {
                                    configuration.itemText !== null && configuration.hasItemRestoreButton ?
                                        <span
                                            className={`_ItemRestoreButton ${buttons[itemRestoreButtonKey].buttonCssClass}`}
                                            onClick={(event) => this.resetScaleSliderResponse(event, configuration)}
                                        >
                                            {
                                                (this.state.undoIcon === true && this.state.naCheck === false) && isDeleteIcon ?
                                                    <i className={buttons[itemRestoreButtonKey].buttonFontAwesome}></i>
                                                    :
                                                    null
                                                }
                                        </span>
                                    :null
                                }
                            </Col>
                        :null}
                    </Row>
                    {/* <Row className={"ItemSlider-row"}>
                        <Col md={1}></Col>
                        <Col md={10}>

                        </Col>
                    </Row> */}
                    <Row>
                        <Col xs={1}>
                            <div className={"ItemSpinner"}>
                                {this.renderSpinner(configuration)}
                            </div>
                        </Col>
                        <Col xs={configuration.itemText && configuration.itemText !== null ? 10 : 10}
                            style={{display:tempScales.length > 1 ? "block" : "flex"}}
                            className={`_ItemSlider ${configuration.cssClass}`}

                        >
                            { !configuration.isOneChanceItem ? this.renderView(configuration, rateeKey, configuration.key)
                            :configuration.oneChanceSectionKey !== null && sections.hasOwnProperty(configuration.oneChanceSectionKey) ? sections[configuration.oneChanceSectionKey].content:null}
                        </Col>
                        <Col xs={1}></Col>
                    </Row>
                </div>
            );
        } else {
            jsx = (
                <div id={`survey-item-block_${configuration.key}`} className={`survey-item-block survey-item-blocks_${configuration.key}`}>
                    <Row
                        id={`ScrollDiv_${configuration.key !== undefined ? configuration.key:null}`}
                        className={configuration.itemText && configuration.itemText !== null ? "_ItemTextCss justify-content-md-center" : null}>
                        {
                            configuration.itemText && configuration.itemText !== null ?
                                <>
                                    <Col xs={1}>
                                        {/* <i className="fa fa-spinner fa-spin" style={{"fontSize":"20px"}}></i> */}
                                    </Col>
                                    <Col
                                        xs={naResponse !== null && naResponse !== undefined && configuration.hasItemResetButton && configuration.hasItemRestoreButton ? 10 : 10}
                                        className="itemText"
                                    >
                                        {configuration.isRequiredLabel === true ? <span className={"_AsteriskMark"}>{properties.requiredIndicator}</span> :''}
                                        <span className="itemTag" dangerouslySetInnerHTML={{__html:configuration.itemTag}}></span>
                                        <span dangerouslySetInnerHTML={{__html: processResponse(configuration.itemText)}}></span>
                                    </Col>
                                    <Col xs={1}></Col>
                                </>
                            :null
                        }

                        {configuration.itemText && configuration.itemText !== null ?
                            <Col xs={1}
                                className={groupIconsClass}
                                style={{display: naResponse !== null && naResponse !== undefined && configuration.hasItemResetButton && configuration.hasItemRestoreButton ? "block":"none"}}
                            >
                                {naResponse !== null && naResponse !== undefined ? <span>
                                    <Form.Check
                                        className={`_ItemNaUncheckedButton ${buttons[itemNaUncheckedButtonKey].buttonCssClass}`}
                                        type="checkbox"
                                        onChange={(event) => this.scaleSliderNaCheck(event, configuration)}
                                    />
                                        <span>{buttons[itemNaUncheckedButtonKey].buttonText}</span>
                                </span>:null}
                                {
                                    configuration.itemText !== null && configuration.hasItemResetButton ?
                                        <span
                                            className={`_ItemResetButton ${buttons[itemResetButtonKey].buttonCssClass}`}
                                            onClick={(event) => this.resetAll(event, configuration, rateeKey, "clear")}
                                        >
                                            {
                                                (scaleCompIcons.length > 0 && this.state.undoIcon === false) || scaleCompIcons.length > 0 ?
                                                    <i className={buttons[itemResetButtonKey].buttonFontAwesome}></i>
                                                :
                                                    isDeleteIcon = true
                                            }
                                        </span>
                                    :null
                                }
                                {
                                    configuration.itemText !== null && configuration.hasItemRestoreButton ?
                                        <span
                                            className={`_ItemRestoreButton ${buttons[itemRestoreButtonKey].buttonCssClass}`}
                                            onClick={(event) => this.resetScaleSliderResponse(event, configuration)}
                                        >
                                            {
                                                (this.state.undoIcon === true && this.state.naCheck === false) && isDeleteIcon ?
                                                    <i className={buttons[itemRestoreButtonKey].buttonFontAwesome}></i>
                                                    :
                                                    null
                                                }
                                        </span>
                                    :null
                                }
                            </Col>
                        :null}
                    </Row>
                    {/* <Row> */}
                        {/* <div className="SingleOrMultiSelectGroup _ItemSlider"> */} 
                        {/* old Code */}
                        <div className="SingleOrMultiSelectGroup">
                            <table className="tableColumn">
                            <tbody >
                            { configuration.layoutHints !== "slider" || configuration.layoutHints !== "singleselectdropdown" ? null:
                                <tr>
                                    <th colSpan="1"></th>
									{
										configuration.scale != null && configuration.scale.scaleResponses != null ? configuration.scale.scaleResponses.map(responseConfiguration => {
											return <th key={responseConfiguration.key} dangerouslySetInnerHTML={{__html: responseConfiguration.responseDescription}}></th>;
										}) : null
									}
                                </tr>

                            }
								{ratees.length > 0 ? ratees.map(ratee => {
									return (
										<tr key={ratee.dataCollectionGuid} >
											<td key={ratee.key} className='RateeName' title={ratee.relationshipDescription}>
												{(ratee.participantFirstName !== null ? ratee.participantFirstName: "") +" "+ (ratee.participantLastName !== null ? ratee.participantLastName: "")}
                                                {/* {ratee.dataCollectionGuid} */}
											</td >
                                            {/* <div id={`${configuration.cssClass}_${configuration.key}_${rateeKey}`}> */}
											    {this.renderPointSliderGroup(ratee, this)}
                                            {/* </div> */}
										</tr>
									);
								}, this) : null
							}
                            </tbody>
                        </table>
                        </div>
                    {/* </Row> */}
                    {/* <div className='SingleOrMultiSelectGroup _ItemSlider'>  old code */}
                    <div className='SingleOrMultiSelectGroup'>

                    </div>
                </div>
            );
        }

        return jsx;
    }
}

const mapStateToProps = state => ({
    scrollToQuestionId:state.survey.scrollToQuestionId,
    answeredQuestionCount:state.survey.answeredQuestionCount,
    assessmentInfosForDataCollection:state.survey.assessmentInfoDataCollectionData
});

export default connect(mapStateToProps)(ScaleSliderItem);
